export default {
  title: {
    add: 'Ajouter un script',
    update: 'Modifier le script',
  },
  form: {
    strategy: {
      label: 'Stratégie',
      placeholder: 'Sélectionner une stratégie',
    },
    source: {
      label: 'Source (src)',
      placeholder: 'Saisir la source',
    },
    async: {
      label: 'Async',
      placeholder: 'Sélectionner Async',
    },
    content: {
      label: 'Contenu',
      placeholder: 'Saisir le contenu',
    },
  },
  alert: {
    use_case: "Cas d'usage",
  },
  buttons: {
    save: 'Enregistrer',
  },
};
